<template>
  <img :src="base64Image" :alt="`Photo de ${alt}`" />
</template>

<script>
export default {
  name: "base64-to-image",
  props: {
    base64Image: null,
    alt: null,
  },
};
</script>

<style></style>
